var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "groups-wrap" }, [
    !_vm.loading && _vm.availableGroups.length < 1
      ? _c("div", { staticClass: "no-results" }, [
          _vm._v(" No subscription groups detected "),
        ])
      : _vm._e(),
    !_vm.loading && _vm.availableGroups.length > 0
      ? _c(
          "div",
          { staticClass: "groups-cont" },
          _vm._l(_vm.availableGroups, function (subItem, subIndex) {
            return _c("subscription-group-option", {
              key: `sub-option-key-${subIndex}`,
              attrs: {
                "subscription-group-data": subItem,
                loading: subItem.loading,
              },
              on: {
                toggle: function ($event) {
                  !subItem.loading ? _vm.toggleOption(subIndex) : null
                },
              },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }